module.exports = __webpack_public_path__ + "media/shape/shape-176-c83de6f7.png";